import React from 'react'
import { Box, Paper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { createInventoryColumnDefinitions } from '../constants/columnDefinitions'

import { InventoryTableProps } from './InventoryTable.types'
import { InventoryReport } from 'lib/services/api/product-service/getInventoryReport/types'

import { useInventoryReport } from '../InventoryReportProvider'

import styles from './InventoryTable.module.scss'

const InventoryTable: React.FC<InventoryTableProps> = ({
  assets,
  isLoading,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
}) => {
  const { setDetailsModal, setParValueModal } = useInventoryReport()

  const handleEditParValue = (row: InventoryReport) => {
    setParValueModal({ data: row, open: true })
  }

  const handleRowClick = (params: any) => {
    setDetailsModal({ data: params.row, open: true })
  }

  const columns = createInventoryColumnDefinitions(handleEditParValue)

  const rows = assets.map((asset, index) => ({
    id: `${asset.parValueId}-${index}`,
    ...asset,
  }))

  return (
    <Box className={styles.container}>
      <Paper elevation={2} className={styles.tablePaper}>
        <DataGrid
          rows={isLoading ? [] : rows}
          columns={columns}
          className={styles.dataGrid}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
          pageSizeOptions={[25, 50, 100]}
          onRowClick={handleRowClick}
          getRowHeight={() => 'auto'}
          loading={isLoading}
          sx={{
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
              minHeight: '56px !important',
            },
            '& .MuiDataGrid-cell': {
              padding: '12px 16px',
              alignItems: 'flex-start',
              display: 'flex',
            },
          }}
        />
      </Paper>
    </Box>
  )
}

export default InventoryTable
